import React from 'react'

export default function Search({ className, onClick }) {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      className={className}
      onClick={onClick}
    >
      <path
        fill="currentColor"
        d="M12.379 10.996a6.874 6.874 0 001.249-5.454C13.111 2.817 10.917.618 8.192.112A6.896 6.896 0 00.121 8.229c.518 2.721 2.722 4.906 5.444 5.412a6.862 6.862 0 005.424-1.254l4.324 4.328a.984.984 0 001.391-1.391l-4.325-4.328zM2.138 8.22a4.934 4.934 0 016.077-6.084 4.85 4.85 0 013.398 3.409 4.934 4.934 0 01-6.07 6.074A4.85 4.85 0 012.138 8.22z"
      />
    </svg>
  )
}
